import axios from "axios";
const service = axios.create({
    // baseURL: 'http://192.168.18.247:8095',
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 50000
})
service.cancelToken = axios.CancelToken;
// request interceptor
service.interceptors.request.use(
    config => {
        // Do something before request is sent
        config.headers['Authorization'] = '+Zj8rL1umNrlOQj3kDyFhyNG+s0PNWZgfVuINUAKn2Xy/J7lu16YcoGrckb7I86EQ/osyfFiJD8bELjUBTgdMDcnAzAlkS1DHe4xzSMG7ts3MpcomEOt7TG/irlTLLBy';
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        // loadinginstace.close()
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    // response => response,
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
    response => {
        // loadinginstace.close()
        if (response.data.success !== undefined) {
            if (!response.data.success) {
                return Promise.reject(response.data.message)
            }
        }
        return response.data
    },
    error => {
        return Promise.reject(error)
    }
)
export default service